import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { School } from '../../../classes/school';

@Component({
    selector: 'app-edit-schools-modal',
    templateUrl: './edit-schools-modal.component.html',
    imports: [
        MatDialogModule,
        MatCheckboxModule,
        FormsModule,
        MatButtonModule
    ]
})
export class EditSchoolsModalComponent implements OnInit {
    protected readonly dialogRef = inject(MatDialogRef<EditSchoolsModalComponent>);
    protected readonly data: {
        selectedSchools: School[];
        allSchools: School[];
        scholarshipName: string;
    } = inject(MAT_DIALOG_DATA);
    selectedSchools: School[] = []; //is used to see if user changed from initial value
    initSchools: School[] = []; //initial value of school list
    submitted: boolean = false; //has user clicked the submit button? is used to display errors
    formEdited: boolean = false; //has value been changed from init value?

    ngOnInit() {
        for (let s of this.data.allSchools) {
            let sch: School = {
                SchoolNumber: s.SchoolNumber,
                SchoolName: s.SchoolName,
                IsChecked: false,
            };

            if (
                this.data.selectedSchools.find(
                    (f) => f.SchoolNumber === s.SchoolNumber
                ) != null
            ) {
                sch.IsChecked = true;
            }

            this.selectedSchools.push(sch);
            this.initSchools.push(sch);
        }
    }

    onChange(val: School[]) {
        this.formEdited = this.selectedSchools !== this.initSchools;
    }

    closeDialog() {
        this.dialogRef.close(null);
    }

    submit() {
        this.submitted = true;

        if (this.formEdited === false) {
            return;
        }

        this.dialogRef.close(
            this.selectedSchools.filter((f) => f.IsChecked === true)
        );
    }
}
